// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"tabs_tabsWrapper__s7c6W"};